export function TermsPage() {
	return (
		<section className="panel">
			<header className="panel__section">
				<h1 className="panel__title">QuickID 利用規約</h1>
				<p className="panel__text">
					最終更新日：2025年10月13日／制定日：2025年10月8日
				</p>
				<p className="panel__text">
					QuickID
					利用規約（以下「本規約」）は、合同会社Monello（以下「当社」）が提供するアプリケーション「QuickID」（以下「本サービス」）の利用条件を定めるものです。本サービスの利用者（以下「利用者」）は、iOS端末に本サービスのアプリケーションをインストールし、本サービスの利用を開始した時点で、本規約に同意したものとみなされます。
				</p>
			</header>

			<section className="panel__section">
				<h2 className="panel__section-title">第1条（適用）</h2>
				<p className="panel__text">
					本規約は、本サービスの提供条件及び当社と利用者との間の権利義務関係を定め、利用者の一切の利用行為に適用されます。
				</p>
				<p className="panel__text">
					利用者は、本サービスの利用に当たり本規約の規定を遵守するものとします。
				</p>
			</section>

			<section className="panel__section">
				<h2 className="panel__section-title">第2条（定義）</h2>
				<p className="panel__text">
					「元画像」：利用者が本サービスにアップロードした画像データ。
				</p>
				<p className="panel__text">
					「生成画像」：元画像を基にAI処理によって生成された画像。
				</p>
				<p className="panel__text">
					「外部サービス」：当社が本サービスの提供に際し利用する、第三者が提供するクラウドストレージ、計算資源、機械学習APIその他関連サービス。
				</p>
			</section>

			<section className="panel__section">
				<h2 className="panel__section-title">第3条（提供者情報）</h2>
				<p className="panel__text">運営会社：合同会社Monello（Monello LLC）</p>
				<p className="panel__text">
					所在地：〒154-0004 東京都世田谷区太子堂4丁目18番15号 マガザン三軒茶屋2
					3F-3
				</p>
				<p className="panel__text">
					問い合わせ先：
					<a className="secondary-link" href="mailto:info@monello.jp">
						info@monello.jp
					</a>
				</p>
			</section>

			<section className="panel__section">
				<h2 className="panel__section-title">第4条（利用資格・年齢）</h2>
				<p className="panel__text">
					本サービスは18歳以上のみ利用できます。18歳未満は利用できません。
				</p>
				<p className="panel__text">
					当社は、利用資格に関する申告が虚偽であると判断した場合、本サービスの利用の全部又は一部を停止・終了できます。当社は、かかる本サービスの利用の停止・終了に起因してお客様が被った損害について、一切責任を負わないものとします。
				</p>
			</section>

			<section className="panel__section">
				<h2 className="panel__section-title">
					第5条（本サービスの内容と利用範囲）
				</h2>
				<p className="panel__text">
					本サービスは、元画像を基にAI技術により生成画像を作成し、利用者の端末に送信するものです。生成画像を作成の過程で、背景の単色化等、画像の加工が行われる場合があります。
				</p>
				<p className="panel__text">
					利用者は、元画像等の本サービスへの入力情報に関し、必要な全ての権利、ライセンス及び許諾を有することを表明し、保証します。また、利用者は、著作権法、商標法その他の法令違反、公序良俗違反、又は第三者の権利侵害のおそれのある情報を入力しないものとします。
				</p>
				<p className="panel__text">
					本サービス及び生成画像は、利用者自身の責任において利用するものとします。当社は、本サービス及び生成画像の利用に関して利用者や第三者に生じた損害又は利用者と第三者との間で生じた紛争について、当社の故意又は重過失の場合を除き、一切の責任を負わないものとします。
				</p>
				<p className="panel__text">
					当社は、生成画像にAI生成物であることの識別に資する表示又は識別子を付す場合があります。利用者は、これらの技術的保護手段の回避・除去を行ってはなりません。
				</p>
			</section>

			<section className="panel__section">
				<h2 className="panel__section-title">第6条（データの取扱い）</h2>
				<p className="panel__text">
					元画像は処理のため外部サービスに一時的に保管され、処理に必要な期間のみ保持し、完了後は速やかに削除します。
				</p>
				<p className="panel__text">
					生成画像は当社サーバーには原則保存しません。生成画像の保存・管理は利用者の責任で行うものとします。
				</p>
				<p className="panel__text">
					当社は、サービス品質向上・不正利用防止・運用のため、個人を特定しない統計情報（処理回数、処理時間、エラー率等）を収集・利用する場合があります。収集する情報・利用目的・保存期間等の詳細はプライバシーポリシーに定めます。
				</p>
				<p className="panel__text">
					利用者の入力情報等、本サービスにおける個人情報の取扱いは、プライバシーポリシーに定めます。
				</p>
			</section>

			<section className="panel__section">
				<h2 className="panel__section-title">第7条（利用環境の整備）</h2>
				<p className="panel__text">
					利用者は、必要な端末、OS、通信回線等の環境を自己の費用と責任で準備・維持します。
				</p>
				<p className="panel__text">
					本サービスは、元画像を基にAI技術により生成画像を作成するものであり、同一の元画像から常に同一品質の結果が得られることは保証されません。
				</p>
			</section>

			<section className="panel__section">
				<h2 className="panel__section-title">第8条（料金・支払・解約）</h2>
				<p className="panel__text">
					本サービスはサブスクリプション（自動更新）により提供されます。価格、提供内容等は当社が定め、本サービス内又はApp
					Store上で表示します。
				</p>
				<p className="panel__text">
					料金は利用者のApple IDを通じてAppleが代行し、App
					Storeの規約・支払条件が適用されます。解約は利用者自身がサブスクリプション管理にて行ってください。
				</p>
				<p className="panel__text">
					本サービスの解約は次回更新日時の24時間以上前までに行ってください。期間途中の解約の場合、更新日をもって解約されることとし、残期間は利用可能であり、残期間における本サービス利用料金は返金しないものとします。
				</p>
				<p className="panel__text">
					利用者が本規約に違反したことを理由に、当社が期間途中に本サービスの利用を停止・終了する場合、既に支払われている本サービスの利用料は返金しないものとします。
				</p>
				<p className="panel__text">
					当社は、本サービスのプランの内容（価格を含むが、これに限られない。）を変更できます。かかる変更は本サービス内又はApp
					Store上で告知し、告知において定める効力発生日以降に適用されます。
				</p>
			</section>

			<section className="panel__section">
				<h2 className="panel__section-title">第9条（禁止事項）</h2>
				<p className="panel__text">
					本サービス又は生成画像の利用に際し、当社は次の各号の行為を禁止します。
				</p>
				<p className="panel__text">
					当社若しくは第三者の権利等を侵害し、又は侵害するおそれのある行為
				</p>
				<p className="panel__text">
					当社又は第三者の名誉、信用又は評判等を毀損、不当に差別、誹謗中傷し、又は脅迫する行為
				</p>
				<p className="panel__text">
					当社若しくは第三者の財産を侵害し、又は侵害するおそれのある行為
				</p>
				<p className="panel__text">
					当社又は第三者に経済的損害を与え、又は与えるおそれのある行為
				</p>
				<p className="panel__text">
					法令に違反する行為、公序良俗に反する行為及び反社会的な行為
				</p>
				<p className="panel__text">
					当社及び当社サービスのイメージを損なう行為
				</p>
				<p className="panel__text">
					本サービスを変更又は複製、並びに第三者に販売し又は配布する行為
				</p>
				<p className="panel__text">
					本サービスに関するプログラムの全部又は一部を閲覧若しくは分析し、又は盗用、複製、改変、若しくは第三者に開示する行為
				</p>
				<p className="panel__text">
					本サービスに係るアルゴリズム、又はシステムを含む、本サービスのソースコード又は基礎となるコンポーネントの発見、リバースエンジニアリング、逆コンパイルについて試みたり、他者を支援すること（当該制限が適用法令で禁止されている場合を除く）
				</p>
				<p className="panel__text">
					データ又は生成物を自動又はプログラムにより引き出すこと
				</p>
				<p className="panel__text">生成物を人が作り出したものと表示すること</p>
				<p className="panel__text">
					レート制限や規制を回避したり、当社が本サービスに実装させている保護措置や安全管理上の緩和対策を迂回したりするなど、本サービスを妨害又は中断させること
				</p>
				<p className="panel__text">
					本サービスのインフラ設備に対して負荷をかける行為
				</p>
				<p className="panel__text">
					本サービスのサーバーやシステム、セキュリティへの攻撃
				</p>
				<p className="panel__text">上記の他、当社が不適切と認める行為</p>
			</section>

			<section className="panel__section">
				<h2 className="panel__section-title">
					第10条（知的財産権・ライセンス）
				</h2>
				<p className="panel__text">
					本サービスに関するプログラム、デザイン、ロゴ、ドキュメント等の知的財産権は当社又は権利者に帰属します。生成プロセスに用いられるモデル、アルゴリズム、プロンプト、ワークフロー等の権利は当社又は正当な権利者に帰属します。
				</p>
				<p className="panel__text">
					利用者は、生成画像を本規約の遵守を条件として、利用することができるものとします。
				</p>
			</section>

			<section className="panel__section">
				<h2 className="panel__section-title">第11条（反社会的勢力の排除）</h2>
				<p className="panel__text">
					利用者は反社会的勢力に該当せず、また、反社会的勢力と関係を有しないことを表明・保証します。利用者が本条項に違反した場合、当社は通知なく本サービスの提供を停止・終了でき、かかる提供・終了に起因する損害について一切の責任を負わないものとします。
				</p>
			</section>

			<section className="panel__section">
				<h2 className="panel__section-title">第12条（保証の否認）</h2>
				<p className="panel__text">
					本サービスは現状有姿で提供されます。当社は、生成結果の正確性、信頼性、適切性、最新性、完全性、有効性、特定目的への適合性、有用性、法令適合性及び継続性並びに生成物の利用が第三者の権利等を侵害しないこと等（以下「正確性等」）について、明示黙示を問わず一切保証しません。利用者は、正確性等について確認する責任があることを十分認識し、利用者自身の責任で生成画像を利用するものとします。
				</p>
			</section>

			<section className="panel__section">
				<h2 className="panel__section-title">第13条（責任の制限）</h2>
				<p className="panel__text">
					当社は、本サービスの提供・中断・変更・利用不能、データの消失・破損、越境移転、外部サービスの障害等、本サービスに関連して利用者に生じた一切の損害（間接・特別・結果的損害、逸失利益を含む）について、当社の故意又は重過失の場合を除き、責任を負いません。
				</p>
				<p className="panel__text">
					当社が利用者に対して賠償責任を負う場合、賠償金額は、過去3か月間に利用者が当社に実際に支払ったサブスクリプション料金の総額を上限とします。
				</p>
			</section>

			<section className="panel__section">
				<h2 className="panel__section-title">
					第14条（サービスの変更・中断・終了）
				</h2>
				<p className="panel__text">
					当社は、保守、障害、外部サービスの変更・終了、法令対応、その他やむを得ない事由により、本サービスの内容変更・中断・終了を行うことがあります。かかる内容変更・中断・終了に起因して利用者に生じた損害について、当社の故意又は重過失の場合を除き、当社は一切の責任を負わないものとします。
				</p>
				<p className="panel__text">
					緊急の場合を除き、本サービス内又はApp Store上で事前に通知します。
				</p>
			</section>

			<section className="panel__section">
				<h2 className="panel__section-title">第15条（契約期間・利用停止）</h2>
				<p className="panel__text">
					本規約は、利用者が本規約に同意した時点で成立し、利用者の解約又は当社の本サービス提供終了まで有効です。
				</p>
				<p className="panel__text">
					利用者が本規約に違反した場合、当社は催告なく直ちに利用停止又は契約解除を行うことができます。かかる利用停止又は契約解除に起因して利用者に生じた損害について、当社は一切の責任を負いません。
				</p>
			</section>

			<section className="panel__section">
				<h2 className="panel__section-title">第16条（規約の変更）</h2>
				<p className="panel__text">
					当社は必要に応じて本規約を変更できます。重要な変更は、本サービス内リンク又はApp
					Store上で通知し、当社が通知において定める効力発生日から適用します。変更後に利用者が本サービスを利用した場合、当該変更に同意したものとみなします。
				</p>
			</section>

			<section className="panel__section">
				<h2 className="panel__section-title">第17条（権利義務の譲渡禁止）</h2>
				<p className="panel__text">
					利用者は、当社の事前の書面承諾なく、本規約上の地位又は権利義務を第三者に譲渡・移転・担保設定できません。当社は、事業譲渡等に伴い本規約上の地位及び権利義務を第三者に承継させることができます。
				</p>
			</section>

			<section className="panel__section">
				<h2 className="panel__section-title">第18条（通知・連絡）</h2>
				<p className="panel__text">
					当社からの通知は、本サービス内表示、App
					Store上の表示、その他当社が適当と判断する方法により行います。利用者から当社への連絡は、原則として
					<a className="secondary-link" href="mailto:info@monello.jp">
						info@monello.jp
					</a>
					宛のメールによります。
				</p>
			</section>

			<section className="panel__section">
				<h2 className="panel__section-title">第19条（存続）</h2>
				<p className="panel__text">
					第5条、第9条〜第13条及び第17条〜第20条は、利用契約終了後も有効に存続します。
				</p>
			</section>

			<section className="panel__section">
				<h2 className="panel__section-title">第20条（分離可能性）</h2>
				<p className="panel__text">
					本規約の一部が無効・執行不能でも、残余は引き続き有効に存続します。
				</p>
			</section>

			<section className="panel__section">
				<h2 className="panel__section-title">第21条（準拠法・裁判管轄）</h2>
				<p className="panel__text">
					本規約は日本法を準拠法とし、本サービスに関する紛争は東京地方裁判所を第一審の専属的合意管轄裁判所とします。
				</p>
			</section>

			<section className="panel__section">
				<p className="panel__text">
					問い合わせ先：
					<a className="secondary-link" href="mailto:info@monello.jp">
						info@monello.jp
					</a>
				</p>
			</section>
		</section>
	);
}
